<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <div class="section big-55-height over-hide z-bigger">
      <div class="parallax parallax-top" style="background-image: url('img/1.jpg')"></div>
      <div class="dark-over-pages"></div>

      <div class="hero-center-section pages">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 parallax-fade-top">
              <div class="hero-text">Booking Details</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="section book-toolbar-details">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 text-left">
            <div>
              <h6>
                <b>Dates</b>
              </h6>
            </div>
            <span>{{ userQuery.checkIn }} - {{ userQuery.checkOut }}</span>
          </div>
          <div class="col-lg-6 text-left">
            <div>
              <h6>
                <b>Rooms & Guests</b>
              </h6>
            </div>
            <span>1 Room : {{ userQuery.guests }} Guests</span>
          </div>
        </div>
      </div>
    </div> -->

    <div class="section padding-top-bottom z-bigger">
      <div class="section z-bigger">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 mt-4">
              <div class="room-box background-grey">
                <div style="display: flex">
                  <div class="col-lg-6 p-0">
                    <div class="room-name">{{ room.roomName }}</div>
                    <img :src="room.image" alt style="width: 100%; height: 100%">
                  </div>
                  <div class="col-lg-6  align-self-center">
                    <div class="row px-4">
                      <div class="col-lg-12">
                        <h4>{{ room.roomName }}</h4>
                        <br>
                        <div class="row p-4">
                          <table class="table table-bordered table-striped">
                            <tbody>
                              <tr>
                                  <td>Check in</td>
                                  <td>{{ requestDetails.checkInDate }}</td>
                              </tr>
                              <tr>
                                  <td>Check out</td>
                                  <td>{{ requestDetails.checkOutDate }}</td>
                              </tr>
                              <!-- <tr>
                                  <td>Guests</td>
                                  <td>{{ requestDetails.numberOfGuests }}</td>
                              </tr> -->
                              <tr>
                                  <td>Room rate</td>
                                  <td>{{ rate.ratePlanName }}</td>
                              </tr>
                              <!-- <tr>
                                  <td>
                                      <strong>Price per Night</strong>
                                  </td>
                                  <td><strong>${{  rate.rateCost }}</strong></td>
                              </tr> -->
                              <!-- <tr>
                                  <td>
                                      <strong>Number of rooms</strong>
                                  </td>
                                  <td><strong>{{  requestDetails.numberOfRooms }}</strong></td>
                              </tr> -->
                              <tr>
                                  <td>
                                      <strong>Total</strong>
                                  </td>
                                  <td><strong>${{  (parseInt(requestDetails.total)/(10 ** parseInt(requestDetails.decimalPlaces))) }}</strong></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>                 
                </div>
              </div>
            </div>
            <div class="col-lg-12 mt-4">
              <div class="room-box" style="background:#efefef">
                <div style="display: flex">

                  <div class="room-box-in col-lg-12 row ">
                    <div class="row">
                      <form class="col-8 offset-2">
                        
                        <div class="row">
                          <div class="form-group col-6">
                            <label for="" class="col-12">First name</label>
                            <input v-model="requestDetails.firstName" type="text" name="first_name"  class="form-control" placeholder="Enter your first name">
                          </div>
                          <div class="form-group col-6">
                            <label for="" class="col-12">Last name</label>
                            <input v-model="requestDetails.lastName" type="text" name="last_name" class="form-control" placeholder="Enter your last name">
                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-6">
                            <label for="" class="col-12">Email</label>
                            <input v-model="requestDetails.email" type="email" name="email" class="form-control" placeholder="Enter your email">
                          </div>
                          <div class="form-group col-6">
                            <label for="" class="col-12">Phone</label>
                            <input v-model="requestDetails.phoneNumber" type="text" name="phone_number" class="form-control" placeholder="Enter your phone number">
                          </div>
                        </div>

                        <!-- <div class="row">
                          <div class="form-group col-6">
                            <label for="" class="col-12">Checkin Date</label>
                            <input type="text" name="start_date" id="checkin" class="form-control" placeholder="Select checkin date">
                          </div>
                          <div class="form-group col-6">
                            <label for="" class="col-12">Checkout Date</label>
                            <input type="text" name="end_date" id="checkout" class="form-control" placeholder="Select checkout date">
                          </div>
                        </div> -->

                        <div class="row">
                          <!-- <div class="form-group col-6">
                            <label for="" class="col-12">Number of guests per room</label>
                            <input v-model="requestDetails.numberOfGuests" type="number" name="number_of_guests" class="form-control" placeholder="Enter number of guests">
                          </div> -->
                          <div class="form-group col-12">
                            <label for="" class="col-12">Number of rooms</label>
                            <input v-model="requestDetails.numberOfRooms" type="number" name="number_of_rooms" class="form-control" placeholder="Enter number of rooms" @change="calculateTotal">
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="form-check-container">Guaranteed booking
                            <input type="checkbox" name="guaranteed" id="guaranteed" v-model="requestDetails.guaranteed">
                            <span class="checkmark"></span>
                          </label>
                          
                        </div>
                        <div class="row">
                          <div class="form-group col-12">
                            <label for="" class="col-12">Additional requests</label>
                            <textarea v-model="requestDetails.additionalMessage" name="additional_message" id="" placeholder="Enter additional message"  class="form-control" cols="30" rows="10"></textarea>
                          </div>
                         
                        </div>
                        <div class="row">
                          <div class=" col-6">
                            <button type="button" class="btn btn-primary" @click="backToRooms($event)">Back to rooms</button>
                          </div>
                          <div class=" col-6 pr-2 mr-0">
                            <button type="button" class="btn btn-success mr-0 float-right" @click="proceedToCheckout($event)">Proceed</button>
                          </div>
                        
                        
                        </div>
                        
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

           
          </div>
        </div>
      </div>
    </div>
    <div class="loader" v-if="loader">
        <div class="loader__figure"></div>
    </div>

    <!-- Modal -->
    <div class="modal fade bd-example-modal-sm" id="messageModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Message</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <ul>
                <li v-for="message in messages" :key="message">{{ message }}</li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from '@/common/Constants.js'
export default {
  name: "search",
  data(){
      return{
        userQuery: {},
        room:{},
        rate:{},
        requestDetails : {
          firstName: '',
          lastName: '',
          email:'',
          phoneNumber: '',
          checkInDate: '',
          checkOutDate: '',
          numberOfGuests: '',
          numberOfRooms: 1,
          Message: '',
          errorMessage: '',
          error: false,
          guaranteed: false,
          roomId: '',
          transactionId: '',
          total : 0,
          rateId: '',
          userSelectedRates : {},
          decimalPlaces : 2

        },
        messages:{},
        loader:false,
        mainCost : 0,

      }
  },
  mounted() {
    $(".owl-carousel").owlCarousel({
      loop: true,
      margin: 10,
      items: 1,
      mouseDrag: true,
      autoWidth: true
    });
    this.userQuery = JSON.parse(localStorage.queryData);
    // console.log(this.userQuery);
    if(localStorage.room){

      
      this.room = JSON.parse(localStorage.room);
      this.rate = JSON.parse(localStorage.rate);
      this.requestDetails.roomId = this.room.roomId;

      this.requestDetails.rateId = this.rate.ratePlanId;
      this.requestDetails.numberOfGuests = this.userQuery.guests;
      this.requestDetails.checkInDate = this.userQuery.checkIn;
      this.requestDetails.checkOutDate = this.userQuery.checkOut;

      this.calculateTotal(true);      
      
    }else{
      this.$router.push('/');
    }   
    const vueInstance = this;
    // var checkin = $("#checkin");
    // checkin.datepicker({
    //   autoclose: true,
    //   format: "yyyy-mm-dd",
    //   maxViewMode: 0,
    //   startDate: "now",
    // }).on("changeDate", function (e) {
    //       var dt2 = $('#checkout');
    //       dt2.datepicker('setStartDate', e.date );
    //       dt2.datepicker('setDate', e.date);
    //       vueInstance.calculateTotal();
    //   });

    // var checkout = $("#checkout");
    // checkout.datepicker({
    //   autoclose: true,
    //   format: "yyyy-mm-dd",
    //   maxViewMode: 0,
    //   startDate: "now"
    // }).on("changeDate", function (e) {
    //     vueInstance.calculateTotal();
    // });
    // $("#checkin").datepicker('setDate', this.userQuery.checkIn);
    // $("#checkout").datepicker('setDate', this.userQuery.checkOut);

    if(localStorage.bookingDetails){
      this.requestDetails =  JSON.parse(localStorage.bookingDetails);
      this.mainCost = this.requestDetails.total;
      // console.log(this.requestDetails);
      // $('#checkin').datepicker('setDate', this.requestDetails.checkInDate);
      // $('#checkout').datepicker('setDate', this.requestDetails.checkOutDate);

    }
  },
  methods : {
    proceedToCheckout(event, guaranteed = false){
        this.loader = true;
        // this.requestDetails.checkInDate = $('#checkin').val();
        // this.requestDetails.checkOutDate = $('#checkout').val();
        this.requestDetails.guaranteed = $("#guaranteed").prop("checked");
        this.requestDetails.transactionId = this.makeid(20);
        // console.log(this.requestDetails);

        if(this.validateQuery(this.requestDetails)){

              this.$http.post(Constants.API_MAKE_RESERVATION_URL, this.requestDetails)
                .then((response) => {
                  // console.log(response);
                    if(this.requestDetails.guaranteed){
                        localStorage.details = JSON.stringify(response.data.details);
                        localStorage.requestDetails = JSON.stringify(this.requestDetails);
                        this.$router.push('/checkout');
                    }else{
                        this.loader = false;
                        var message = ["Reservation booked."];
                        this.messages = message;
                        $('#messageModal').modal();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        if(error.response.status == 400){
                            this.loader = false;
                            var message = error.response.data.message;
                            // console.log(error.response.data.message);
                            this.messages = [message];
                            $('#messageModal').modal();
                        }else if(error.response.status == 403){
                            this.loader = false;
                            this.messages = error.response.data.messages;
                            $('#messageModal').modal();
                        }else{
                            this.loader = false;
                            var message = ["Unable to complete request."];
                            this.messages = message;
                            $('#messageModal').modal();
                        }
                    }
                });
        }else{
            this.loader = false;
            var message = ['Please fill the form correctly'];
            this.messages = message;
            $('#messageModal').modal();
        }
    },

    backToRooms(event){
      this.$router.push('/rooms');
    },

    validateQuery(query){
      if(
          query.lastName != '' &&
          query.firstName != '' &&
          query.email != '' &&
          query.roomId != '' &&
          query.rateId != '' &&
          query.guaranteed !== '' &&
          query.transactionId !== '' &&
          query.phoneNumber != '' &&
          query.checkInDate != '' &&
          query.checkOutDate != '' &&
          // query.numberOfGuests != 0 &&
          // isNaN(query.numberOfGuests) != true &&
          query.numberOfRooms != 0 &&
          isNaN(query.numberOfRooms) != true
      ){
          return true;
      }

      return false;
    },

    makeid(length) {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },

    calculateTotal(isMounted = false){

      if(
        //this.requestDetails.numberOfRooms &&
        this.rate.rateCost &&
        this.requestDetails.checkOutDate &&
        this.requestDetails.checkInDate
      ){
        
        const date1 = new Date(this.requestDetails.checkInDate);
        const date2 = new Date(this.requestDetails.checkOutDate);
        const diffTime = Math.abs(date2.getTime() - date1.getTime());
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        diffDays = (diffDays < 1)? 1: diffDays;
        // console.log(diffDays);
        // console.log(this.requestDetails.numberOfRooms);
        // console.log(this.requestDetails.total);
        // console.log(this.rate.rateCost);
        this.requestDetails.numberOfRooms = (this.requestDetails.numberOfRooms) ? this.requestDetails.numberOfRooms : 1;

        this.requestDetails.numberOfNights = diffDays;
        this.requestDetails.total = this.mainCost * this.requestDetails.numberOfRooms;
      }
      

    }
  }
};
</script>

<style>
.sliderElem {
  height: 300px;
  background-position: center center;
  border-radius: 4px;
}

.modal-header h5 {
  font-weight: bold;
  display: inline;
}
b {
  font-weight: 900;
}
.room-box {
  overflow: hidden;
}
.label--checkbox {
  position: relative;
  line-height: 135%;
  cursor: pointer;
  background: transparent;
  color: #363636;
  letter-spacing: 1px;
  text-transform: capitalize;
}
.checkbox:before {
  border: 2px solid rgba(0, 0, 0, 0.4);
}
.rate-break-down {
  /* border-bottom: 4px solid gray; */
}
.rate-break-down .row {
  border-bottom: 4px solid #8080803b;
  margin-bottom: 15px;
}

.form-check-container{
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.form-check-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #eee;
  border: 1px solid #6dc234;
}

/* On mouse-over, add a grey background color */
.form-check-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.form-check-container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.form-check-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.form-check-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>

